const placements = {
  tourismBanner: "tourism_banner",
  bannerCategory: "banner_category",
  itemInCategory: "item_in_category",
  underFiltersCategory: "under_filters_category",
  customerPanel: "customer_panel",
};

export default placements;
